var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPractiseQuizz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 166,
    viewBox: "0 0 160 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_62)",
    filter: "url(#filter0_d_3_62)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_62",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 0H0V160H160V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 155C121.421 155 155 121.421 155 80C155 38.5786 121.421 5 80 5C38.5786 5 5 38.5786 5 80C5 121.421 38.5786 155 80 155Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 33H72C66.4772 33 62 37.4772 62 43V112C62 117.523 66.4772 122 72 122H120C125.523 122 130 117.523 130 112V43C130 37.4772 125.523 33 120 33Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 43C62 37.4772 66.4772 33 72 33H120C125.523 33 130 37.4772 130 43V51H62V43Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 32.5C31.3807 32.5 32.5 31.3807 32.5 30C32.5 28.6193 31.3807 27.5 30 27.5C28.6193 27.5 27.5 28.6193 27.5 30C27.5 31.3807 28.6193 32.5 30 32.5Z",
    fill: "#EEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 32.5C38.8807 32.5 40 31.3807 40 30C40 28.6193 38.8807 27.5 37.5 27.5C36.1193 27.5 35 28.6193 35 30C35 31.3807 36.1193 32.5 37.5 32.5Z",
    fill: "#EEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 32.5C46.3807 32.5 47.5 31.3807 47.5 30C47.5 28.6193 46.3807 27.5 45 27.5C43.6193 27.5 42.5 28.6193 42.5 30C42.5 31.3807 43.6193 32.5 45 32.5Z",
    fill: "#EEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 17H28C22.4772 17 18 21.4772 18 27V132C18 137.523 22.4772 142 28 142H104C109.523 142 114 137.523 114 132V27C114 21.4772 109.523 17 104 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27C18 21.4772 22.4772 17 28 17H104C109.523 17 114 21.4772 114 27V42H18V27Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 32C31.8807 32 33 30.8807 33 29.5C33 28.1193 31.8807 27 30.5 27C29.1193 27 28 28.1193 28 29.5C28 30.8807 29.1193 32 30.5 32Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 32C39.3807 32 40.5 30.8807 40.5 29.5C40.5 28.1193 39.3807 27 38 27C36.6193 27 35.5 28.1193 35.5 29.5C35.5 30.8807 36.6193 32 38 32Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 32C46.8807 32 48 30.8807 48 29.5C48 28.1193 46.8807 27 45.5 27C44.1193 27 43 28.1193 43 29.5C43 30.8807 44.1193 32 45.5 32Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 71H50.5C49.1193 71 48 72.1193 48 73.5C48 74.8807 49.1193 76 50.5 76H99.5C100.881 76 102 74.8807 102 73.5C102 72.1193 100.881 71 99.5 71Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 92H50.5C49.1193 92 48 93.1193 48 94.5C48 95.8807 49.1193 97 50.5 97H99.5C100.881 97 102 95.8807 102 94.5C102 93.1193 100.881 92 99.5 92Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 113H50.5C49.1193 113 48 114.119 48 115.5C48 116.881 49.1193 118 50.5 118H99.5C100.881 118 102 116.881 102 115.5C102 114.119 100.881 113 99.5 113Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.398 77.36H30.37L33.538 68.48H35.434L38.59 77.36H36.526L35.902 75.488H33.034L32.398 77.36ZM34.234 71.96L33.598 73.856H35.35L34.714 71.96C34.618 71.66 34.51 71.312 34.474 71.096C34.438 71.3 34.342 71.636 34.234 71.96Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.328 119.664C31.664 119.664 29.996 117.9 29.996 115.092C29.996 112.32 31.76 110.496 34.412 110.496C36.632 110.496 38.228 111.768 38.504 113.76H36.452C36.188 112.872 35.432 112.368 34.364 112.368C32.924 112.368 32.048 113.388 32.048 115.08C32.048 116.748 32.936 117.792 34.364 117.792C35.456 117.792 36.26 117.252 36.5 116.376H38.516C38.204 118.356 36.548 119.664 34.328 119.664Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 103.97C100.74 103.97 90 114.71 90 127.97C90 141.23 100.74 151.97 114 151.97C127.26 151.97 138 141.23 138 127.97C138 114.71 127.26 103.97 114 103.97ZM126.75 140.69C119.7 147.71 108.3 147.71 101.28 140.69L114 127.97V109.97C118.62 109.97 123.21 111.74 126.72 115.25C133.77 122.27 133.77 133.67 126.75 140.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72 115.25C123.21 111.74 118.62 109.97 114 109.97V127.97L101.28 140.69C108.3 147.71 119.7 147.71 126.75 140.69C133.77 133.67 133.77 122.27 126.72 115.25ZM114 97.97C97.44 97.97 84 111.41 84 127.97C84 144.53 97.44 157.97 114 157.97C130.56 157.97 144 144.53 144 127.97C144 111.41 130.56 97.97 114 97.97ZM114 151.97C100.74 151.97 90 141.23 90 127.97C90 114.71 100.74 103.97 114 103.97C127.26 103.97 138 114.71 138 127.97C138 141.23 127.26 151.97 114 151.97Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 88.3334C31.32 88.3334 28.3334 91.32 28.3334 95C28.3334 98.68 31.32 101.667 35 101.667C38.68 101.667 41.6667 98.68 41.6667 95C41.6667 91.32 38.68 88.3334 35 88.3334ZM33.1934 97.86L30.8 95.4667C30.54 95.2067 30.54 94.7867 30.8 94.5267C31.06 94.2667 31.48 94.2667 31.74 94.5267L33.6667 96.4467L38.2534 91.86C38.5134 91.6 38.9334 91.6 39.1934 91.86C39.4534 92.12 39.4534 92.54 39.1934 92.8L34.1334 97.86C33.88 98.12 33.4534 98.12 33.1934 97.86Z",
    fill: "#B10303"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_62",
    x: -4,
    y: 0,
    width: 168,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_62",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractiseQuizz);
export default __webpack_public_path__ + "static/media/Practise_quizz.cde472ec3c37fd8f1a2bc82a755c10f6.svg";
export { ForwardRef as ReactComponent };